<template>
  <div style="display: inline-block"  @drop.capture="onDrop">
    <!-- 图片上传 -->
    <el-upload
      v-if="type === 'img'"
      :class="['logo-uploader', buttonType === 'isButton' ? 'onlyType' : '']"
      :action="action"
      :headers="headers"
      :show-file-list="false"
      :on-success="success"
      :http-request="toUpload"
      :accept="allowType && allowType.toString()"
      :on-preview="handlePreview"
      :before-upload="beforeUpload"
    >
      <img v-if="imageUrl && buttonType !== 'isButton'" :src="imageUrl" class="avatar" alt="" :style="styles" />
      <i v-if="!imageUrl && buttonType !== 'isButton'" class="el-icon-plus logo-uploader-icon" :style="styles"></i>
      <el-button v-if="buttonType === 'isButton'" id="oneIdButton" size="medium" type="primary">上传头像</el-button>
      <slot name="default" />
      <slot name="text" />
      <slot name="tip" />
    </el-upload>
    <!-- 图片上传（非自动上传）-->
    <el-upload
      v-if="type === 'imgFalseAuto'"
      :class="['logo-uploader', buttonType === 'isButton' ? 'onlyType' : '']"
      :auto-upload="false"
      :on-change="consoleFL"
      :show-file-list="false"
      :http-request="toUpload"
      action="string"
      :on-preview="handlePreview"
      :accept="allowType && allowType.toString()"
    >
      <img v-if="imageUrl && buttonType !== 'isButton'" :src="imageUrl" class="avatar" alt="" :style="styles" />
      <i v-if="!imageUrl && buttonType !== 'isButton'" class="el-icon-plus logo-uploader-icon" :style="styles"></i>
      <el-button v-if="buttonType === 'isButton'" id="oneIdButton" size="medium" type="primary">上传头像</el-button>
    </el-upload>
    <!-- 文件上传 -->
    <el-upload
      v-else-if="type === 'file'"
      :drag="drag"
      :disabled="disabled"
      class="upload-demo"
      :http-request="toUpload"
      :action="action"
      :headers="headers"
      :on-change="consoleFL"
      :on-progress="progress"
      :auto-upload="autoUpload"
      :file-list="fileList"
      :show-file-list="showFileList"
      :limit="limit"
      :multiple="multiple"
      :on-exceed="exceed"
      :accept="allowType && allowType.toString()"
      :on-success="success"
      :before-remove="handleRemove"
      :before-upload="beforeUpload"
      :on-preview="handlePreview"
    >
      <slot name="file" />
      <slot />
      <slot name="tip" />
    </el-upload>
    <img v-show="img" :src="img" alt="" />
  </div>
</template>
<script>
import { Api } from '@/api'
import COS from 'cos-js-sdk-v5'
export default {
  name: 'Upload',
  props: {
    // 可否拖拽上传
    drag: {
      type: Boolean,
      default: false
    },
    // 上传类型
    type: {
      type: String,
      default: 'img'
    },
    // 按钮类型
    buttonType: {
      type: String,
      default: ''
    },
    // 允许上传的文件集合
    allowType: {
      type: Array,
      default: null
    },
    // 允许上传的文件大小
    allowSize: {
      type: Number,
      default: 10
    },
    // 图片地址
    imageUrl: {
      type: String,
      default: ''
    },
    // 样式
    styles: {
      type: Object,
      default: () => {}
    },
    // 自动上传
    autoUpload: {
      type: Boolean,
      default: true
    },
    // 上传是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 文件列表
    fileList: {
      type: Array,
      default: () => []
    },
    path: {
      type: String,
      default: '/file/upload'
    },
    // 文件个数限制
    limit: {
      type: Number,
      default: 1
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // 是否显示文件列表
    showFileList: {
      type: Boolean,
      default: false
    },
    actionPath2: {
      type: String,
      default: ''
    },
    uploadType: {
      // 文件中需要调用多个文件上传组件时，可用此参数自定义区分
      type: String,
      default: ''
    },
    encryption: {
      // 文件是否加密处理
      type: Boolean,
      default: false
    },
    needScretType: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      action: this.actionPath(),
      headers: {},
      img: '',
      previewFileList: []
    }
  },
  methods: {
    handlePreview(val) {
      console.log('val', val)
      this.$emit('preview', val)
    },
    toUpload(file) {
      //   generatorUploadUrl // 生成上传文件的预签名连接 URL
      //     generatorSign // 生成签名
      //     generatorTempSecretId// 临时生成签名
      if (this.encryption) {
        // 腾讯云加密文件处理
        this.uploadDencryption(file)
      } else {
        // 腾讯云不加密文件处理
        // this.uploadDencryption(file)
        this.uploadNormal(file)
      }
    },
    uploadNormal(file) {
      // 不加密文件
      var that = this
      //   const formData = new FormData()
      //   formData.append('file', file.file ? file.file : file)
      //   Api.uploadFile(formData).then(res => {
      //     if (res.code === '0') {
      //       that.$emit('uploadSuccess', { name: file.file.name, path: res.data, id: new Date().getTime(), uploadType: that.uploadType })
      //     }
      //   })
      // cos非加密方法暂时保留 签名：generatorSign 临时签名generatorTempSecretId
      Api.generatorTempSecretId({ filename: encodeURIComponent(file.file.name), type: this.needScretType ? 1 : '' }).then(res => {
        if (res && res.code === '0') {
          console.log(res, 'resres')
          var cos = new COS({
            SecretId: res.data.tmpSecretId,
            SecretKey: res.data.tmpSecretKey,
            XCosSecurityToken: res.data.sessionToken
          })
          cos.uploadFile(
            {
              Bucket: res.data.bucket /* 填写自己的 bucket，必须字段 公共桶 */,
              Region: res.data.region /* 存储桶所在地域，必须字段 */,
              Key: res.data.path /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
              Body: file.file // 上传文件对象
            },
            function(err, data) {
              if (err) {
                console.log('上传出错', err)
              } else {
                console.log('上传成功', data)
                var key = data.Location.split('.com/')[1]
                that.previewFileList.forEach(val => {
                  if (file.file.uid === val.uid) {
                    val.status = 'success'
                    val.url = 'https://' + data.Location
                    val.suffixUrl = res.data.path
                  }
                })
                that.$emit('uploadSuccess', {
                  name: file.file.name,
                  path: 'https://' + data.Location,
                  //   id: file.file.uid,
                  uploadType: that.uploadType
                }, that.previewFileList)
                // Api.getDownloadUrl({ filename: key }).then(url => {
                //   if (url.code === '0') {
                //     that.$emit('uploadSuccess', {
                //       name: file.file.name,
                //       path: url.data.fullUrl,
                //       id: data.RequestId,
                //       uploadType: that.uploadType
                //     })
                //   }
                // })
              }
            }
          )
        }
      })
    },
    uploadDencryption(file) {
      // 腾讯云加密文件处理
      const that = this
      Api.generatorTempSecretId({ filename: encodeURIComponent(file.file.name) })
        .then(res => {
          console.log(res, 'resres')
          if (res && res.code === '0') {
            // this.action = urls.data.uploadUrl
            return res
          }
        })
        .then(res => {
          var cos = new COS({
            getAuthorization: function(options, callback) {
              callback({
                TmpSecretId: res.data.tmpSecretId,
                TmpSecretKey: res.data.tmpSecretKey,
                XCosSecurityToken: res.data.sessionToken,
                StartTime: res.data.startTime,
                ExpiredTime: res.data.expiredTime
              })
            }
          })
          cos.sliceUploadFile(
            {
              Bucket: res.data.bucket /* 必须 */,
              Region: res.data.region /* 存储桶所在地域，必须字段 */,
              Key: res.data.path /* 必须 */,
              Body: file.file,
              uploadId: res.data.uploadId,
              onTaskReady: function(taskId) {
                /* 非必须 */
                that.taskId = taskId
                that.$emit('cancelUp', cos, taskId)
              },
              onHashProgress: function(progressData) {
                /* 非必须 */
                // console.log(JSON.stringify(progressData), '2')
              },
              onProgress: function(progressData) {
                that.$emit('progress', progressData)
                console.log(progressData, 'progressData')
                /* 非必须 */
                // console.log(JSON.stringify(progressData), '3')
              }
            },
            function(err, data) {
              console.log(res.data, 'sssssssssss1')
              console.log(data, '腾讯云返回数据')
              if (err) {
                that.$message.warning('文件上传失败,请重新上传')
                that.$emit('uploadFailed')
              } else {
                // 返回path 然后页面加载通过getDownloadUrl请求获取地址
                that.$emit('uploadSuccess', {
                  name: file.file.name,
                  path: data.Key,
                  //   id: data.UploadId,
                  uploadType: that.uploadType
                }, that.previewFileList)
              }
            }
          )
        })
        .catch(e => {
          that.$emit('uploadFailed')
        })
    },
    actionPath() {
      return this.actionPath2 ? this.actionPath2 : process.env.baseFileUrl + this.path
    },
    // 上传前(非自动上传)
    consoleFL(file, fileList) {
      console.log(319, file, fileList)
      this.previewFileList = fileList
      if (this.autoUpload) return false
      let typeName = '图片'
      if (this.type === 'file') {
        typeName = '文件'
      }
      if (this.allowType) {
        const index = this.allowType.indexOf(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())
        if (index < 0) {
          this.$message({
            message: `上传${typeName}格式不正确`,
            type: 'warning'
          })
          return false
        }
      }
      if (this.allowSize) {
        const b = file.size
        const isLtSize = b > this.allowSize * 1024
        const sizeStr =
          this.allowSize >= 1024 ? `${Math.round((this.allowSize / 1024) * 100) / 100}MB` : `${this.allowSize}KB`
        if (isLtSize) {
          this.$message({
            message: `上传${typeName}大小不能超过${sizeStr}`,
            type: 'error'
          })
          return false
        }
      }
      const url = URL.createObjectURL(file.raw)
      console.log(fileList, '2222222222222222222222222')
      this.$emit('consoleFL', file, fileList, url)
    },
    // 上传成功
    success(res, file) {
      if (res && res.code !== 0) {
        this.$message.error(res.msg)
        return false
      }
      this.$emit('uploadSuccess', res, file)
    },
    // 上传进度
    progress(event, file) {
      this.$emit('uploadProgress', event, file)
    },
    // 上传限制
    exceed(files) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件`)
      this.$emit('exceed', files)
    },
    // 上传前
    beforeUpload(file, fileList) {
      console.log(372, file, fileList)
      let typeName = '图片'
      if (this.type === 'file') {
        typeName = '文件'
      }
      if (this.allowType) {
        const index = this.allowType.indexOf(
          file.name.substring(file.name.lastIndexOf('.')).toLowerCase().toLowerCase()
        )
        if (index < 0) {
          this.$message({
            message: `上传${typeName}格式不正确`,
            type: 'warning'
          })
          return false
        }
      }
      if (this.allowSize) {
        const b = file.size
        const isLtSize = b > this.allowSize * 1024
        const sizeStr =
          this.allowSize >= 1024 ? `${Math.round((this.allowSize / 1024) * 100) / 100}MB` : `${this.allowSize}KB`
        if (isLtSize) {
          this.$message({
            message: `上传${typeName}大小不能超过${sizeStr}`,
            type: 'error'
          })
          return false
        }
      }
      this.$emit('toups', file, fileList)
    },
    // 删除文件
    handleRemove(file, fileList) {
      console.log('handleRemove232', file, fileList)
      this.$emit('handleRemove', file, fileList)
    },
    onDrop(e) {
      if (!this.drag) {
        return
      }
      const hasErrorTypeFile = [...e.dataTransfer.files].some(file => !this.allowType.includes(file.name.substring(file.name.lastIndexOf('.')).toLowerCase()))
      if (hasErrorTypeFile) {
        this.$message({
          message: `文件格式错误`,
          type: 'warning'
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.logo-uploader .onlyType ::v-deep .el-upload {
  border: 0 !important;
}
.logo-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: #f7f7f7;
  &:hover {
    border-color: #409eff;
  }
  .logo-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    object-fit: cover;
    display: block;
  }
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label{
  margin-left: auto;
}
</style>
